<template>
  <InfoWraper>
    <Notification />
    <!-- <Message />
    <Settings />
    <Support />-->
    <div class="nav-author">
      <sdDropdown placement="bottomRight" :action="['click']">
        <template v-slot:overlay>
          <NavAuth>
            <router-link @click="() => onFlagChangeHandle('tr')" to="#">
              <img :src="require('../../../static/img/flag/tr.png')" alt="" />
              <span>Türkçe</span>
            </router-link>
            <router-link @click="() => onFlagChangeHandle('en')" to="#">
              <img :src="require('../../../static/img/flag/en.png')" alt="" />
              <span>English</span>
            </router-link>
          </NavAuth>
        </template>
        <a to="#" class="head-example">
          <img :src="require(`../../../static/img/flag/${flag}.png`)" alt="" />
        </a>
      </sdDropdown>
    </div>

    <div class="nav-author">
      <sdPopover placement="bottomRight" action="click">
        <template v-slot:content>
          <UserDropDwon>
            <div class="user-dropdwon">
              <figure class="user-dropdwon__info">
                <img
                  src="https://cdn0.iconfinder.com/data/icons/user-pictures/100/matureman1-512.png"
                  height="42"
                  width="42"
                  alt=""
                />
                <figcaption>
                  <sdHeading as="h5">{{
                    $store.state.auth.user_name + ' ' + $store.state.auth.user_surname
                  }}</sdHeading>
                  <p>{{ $store.state.auth.user_company }}</p>
                </figcaption>
              </figure>
              <ul class="user-dropdwon__links">
                <li>
                  <router-link :to="{ name: 'set-profile' }" tag="a">
                    <sdFeatherIcons type="settings" /> Ayarlar
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'order-list' }" tag="a">
                    <sdFeatherIcons type="shopping-cart" /> Siparişler
                  </router-link>
                </li>
                <li>
                  <router-link :to="{ name: 'sales' }" tag="a">
                    <sdFeatherIcons type="dollar-sign" /> Satış Performansı
                  </router-link>
                </li>
                <li>
                  <router-link :to="'#'" tag="a"> <sdFeatherIcons type="bell" /> Yardım </router-link>
                </li>
              </ul>
              <a @click="SignOut" class="user-dropdwon__bottomAction" href="#">
                <LogoutOutlined /> {{ $t('header.profile-card.sign-out') }}
              </a>
            </div>
          </UserDropDwon>
        </template>
        <a to="#" class="head-example">
          <a-avatar src="https://cdn0.iconfinder.com/data/icons/user-pictures/100/matureman1-512.png" />
        </a>
      </sdPopover>
    </div>
  </InfoWraper>
</template>

<script>
import { InfoWraper, NavAuth, UserDropDwon } from './auth-info-style';
import Support from './Support';
import Settings from './Settings';
import Notification from './Notification';
import Message from './Message';
import { useStore, mapGetters } from 'vuex';
import { useRouter } from 'vue-router';
import { LogoutOutlined } from '@ant-design/icons-vue';
import store from '@/vuex/store';

export default {
  name: 'AuthInfo',
  components: {
    InfoWraper,
    NavAuth,
    UserDropDwon,
    Support,
    Settings,
    Notification,
    Message,
    LogoutOutlined,
  },
  data() {
    return {
      flag: 'tr',
      useStore: useStore(),
    };
  },

  methods: {
    onFlagChangeHandle: function (value) {
      this.flag = value;
      localStorage.setItem('i_lang', value);
      this.useStore.dispatch('i18n/setLang', value);
      this.$appAxios.post(this.$endpoints.profile_language_set, { language: value }).then((resp) => {
        this.$router.go();
      });
    },
    SignOut() {
      this.$appAxios(this.$endpoints.auth_logout);
      this.$router.push('/auth/login');
      this.useStore.dispatch('logOut');
    },
  },

  created() {
    this.flag = this.app;
  },
  computed: {
    ...mapGetters({
      app: 'i18n/i_lang',
    }),
  },
};
</script>
